import { LoginRequest } from "../models/api/auth/loginRequest";
import { CurrentSessionResponse } from "../models/api/auth/currentSessionResponse";
import { sessionEstablished } from "../../pages/layoutes/authLayout/authSlice";
import { baseApi } from "./baseApi";
import { sessionApi } from "./sessionApi";

const logoutUrl = `${import.meta.env.VITE_HOSTNAME_API}/token/logout`;

export const authApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        takeToken: builder.mutation<CurrentSessionResponse, LoginRequest>({
            query: (body) => ({
                url: `${import.meta.env.VITE_TOKEN}`,
                method: "POST",
                body,
            }),
            // The login endpoint returns the freshly built session payload; seed it directly
            // into the session cache so consumers (PrivateOutlet, useAuth, useUserRole) read
            // the current user without an extra GET /session/me round-trip after login.
            // Also wipe any per-user cache left over from a previous logged-in session and
            // clear the `loggedOut` flag so useAuth resumes subscribing to /session/me.
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(baseApi.util.resetApiState());
                dispatch(sessionApi.util.upsertQueryData("getCurrentSession", undefined, data));
                dispatch(sessionEstablished());
            },
        }),
        logoutUser: builder.mutation<void, void>({
            query: () => ({
                url: logoutUrl,
                method: "POST",
            }),
        }),
    }),
});

export const { useTakeTokenMutation, useLogoutUserMutation } = authApi;

